import { OrderWhereInput, QueryMode } from "../../../generated/graphql";
import { OrderListFilters } from "../contexts/OrderListFilterContext";

const orderListFiltersToQuery = ({
  isArchived,
  references,
  clinicCodes,
  doctors,
  providers,
  statuses,
  createdAt,
  deliveryDate,
  lastShippingDate,
}: Omit<OrderListFilters, "search">): OrderWhereInput => {
  const isArchivedQuery: OrderWhereInput["isArchived"] =
    isArchived != null
      ? {
          equals: isArchived,
        }
      : {};

  const referenceQuery: OrderWhereInput["orderReference"] = references?.length
    ? { in: references }
    : {};
  const clinicCodeQuery: OrderWhereInput["userGroup"] = clinicCodes?.length
    ? { is: { clinicNumber: { in: clinicCodes, mode: QueryMode.Insensitive } } }
    : {};
  const doctorsQuery: OrderWhereInput["user"] = doctors?.length
    ? {
        is: {
          OR: doctors
            .map(doctor => {
              const parts = doctor.split(" ");
              const firstName = parts[0];
              const lastName =
                parts.length > 1 ? parts.slice(1).join(" ") : undefined;

              // If only one part of the name is provided match it with the firstname OR the lastname
              if (!lastName) {
                return [
                  {
                    firstName: {
                      equals: firstName,
                      mode: QueryMode.Insensitive,
                    },
                  },
                  {
                    lastName: {
                      equals: firstName,
                      mode: QueryMode.Insensitive,
                    },
                  },
                ];
              }

              return {
                firstName: {
                  equals: firstName,
                  mode: QueryMode.Insensitive,
                },
                lastName: {
                  equals: lastName,
                  mode: QueryMode.Insensitive,
                },
              };
            })
            .flat(),
        },
      }
    : {};
  const providersQuery: OrderWhereInput["provider"] = providers?.length
    ? {
        is: {
          OR: providers.map(provider => ({
            name: { equals: provider, mode: QueryMode.Insensitive },
          })),
        },
      }
    : {};

  const statusesQuery: OrderWhereInput["status"] = statuses?.length
    ? { in: statuses }
    : {};

  const createdAtQuery: OrderWhereInput["createdAt"] =
    createdAt?.start || createdAt?.end
      ? { gte: createdAt?.start, lte: createdAt?.end }
      : {};

  const deliveryDateQuery: OrderWhereInput["deliveryDate"] =
    deliveryDate?.start || deliveryDate?.end
      ? { gte: deliveryDate?.start, lte: deliveryDate?.end }
      : {};

  const lastShippingDateQuery: OrderWhereInput["lastShippingDate"] =
    lastShippingDate?.start || lastShippingDate?.end
      ? { gte: lastShippingDate?.start, lte: lastShippingDate?.end }
      : {};

  return {
    isArchived: isArchivedQuery,
    orderReference: referenceQuery,
    userGroup: clinicCodeQuery,
    user: doctorsQuery,
    provider: providersQuery,
    status: statusesQuery,
    createdAt: createdAtQuery,
    deliveryDate: deliveryDateQuery,
    lastShippingDate: lastShippingDateQuery,
  };
};

export default orderListFiltersToQuery;
